var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "row" },
    [
      _c(
        "div",
        { staticClass: "col-12 col-lg-4 order-lg-2" },
        [
          _c("account-sidebar", {
            attrs: {
              lng: _vm.lng,
              mainlng: _vm.mainlng,
              translations: _vm.translations,
              accountlink: _vm.accountlink,
              logoutlink: _vm.logoutlink,
              isaccountroute: false,
              account: _vm.account,
              refillaccountlink: _vm.refillaccountlink,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("view-order-container", {
        attrs: {
          lng: _vm.lng,
          mainlng: _vm.mainlng,
          translations: _vm.translations,
          orders: _vm.account.parcels,
          parcel: _vm.parcel,
          ordertype: "arrived",
          paymentmethods: _vm.paymentmethods,
          deliverymethods: _vm.deliverymethods,
          account: _vm.account,
          locations: _vm.locations,
          savedeliverylink: _vm.savedeliverylink,
          dopaymentlink: _vm.dopaymentlink,
          neworderslink: _vm.neworderslink,
          ordersonwarehoselink: _vm.ordersonwarehoselink,
          sentorderslink: _vm.sentorderslink,
          arrivedorderslink: _vm.arrivedorderslink,
          deliveredorderslink: _vm.deliveredorderslink,
          upload_files_link: _vm.upload_files_link,
          delete_files_link: _vm.delete_files_link,
          downloadlink: _vm.downloadlink,
          refusebillLink: _vm.refusebilllink,
          confirmorderlink: _vm.confirmorderlink,
          presavedeliverylink: _vm.presavedeliverylink,
          novaposhtacitysearchlink: _vm.novaposhtacitysearchlink,
          novaposhtastreetsearchlink: _vm.novaposhtastreetsearchlink,
          novaposhtawarehousessearchlink: _vm.novaposhtawarehousessearchlink,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }